import { kebabCase } from "lodash";

export default {
  methods: {
    check(el) {
      let invalidField;
      if (typeof el.$model === "object") {
        if (_.has(el, "$each")) {
          let invalidItem = _.findKey(
            el.$each.$params,
            (value, key) => el.$each[key].$invalid
          );
          if (invalidItem) {
            invalidField = _.findKey(
              el.$each[invalidItem].$params,
              (value, key) => el.$each[invalidItem][key].$invalid
            );
            if (invalidField) {
              invalidField = this.check(invalidField);
              invalidField = invalidItem + "-" + invalidField;
            }
          }
        } else {
          invalidField = _.findKey(
            el.$params,
            (value, key) => el[key].$invalid
          );
        }
      } else {
        invalidField = el;
      }
      return invalidField;
    },
    isValidForm(el) {
      this.$v[el].$touch();
      if (this.$v[el].$invalid) {
        let invalidField;
        invalidField = this.check(this.$v[el]);
        if (invalidField) {
          $("#" + kebabCase(invalidField)).focus();
        }
      }
      return !this.$v[el].$invalid;
    }
  }
};
